import { DataTimestampsDto } from '@asset-metrix/portal-gateway-client-js';
import { QueryFunction, useQuery } from '@tanstack/react-query';

import { HttpError } from '../errors';
import { portalGatewayClient } from '../portalGatewayClient';

const fetchDataTimestamps: QueryFunction<DataTimestampsDto> = async () => {
  const res = await portalGatewayClient.tenant.getDataTimestamps();
  if (res.ok) {
    return res.data.data;
  }

  throw new HttpError('Error fetching data timestamps', res);
};

export function useDataTimestampsQuery() {
  return useQuery({
    gcTime: Infinity,
    queryFn: fetchDataTimestamps,
    queryKey: ['data-timestamps'],
    staleTime: 300_000, // 5 minutes
  });
}
